import { Article } from '~/models/Article';

const filterConditionsMap = {
  trending: (article) => article.tags.includes('home-trending') && !!article.coverImg.src,
  featured: (article) => article.tags.includes('home-featured') && !!article.coverImg.src,
};

export function selectArticles(props, options = {}) {
  const articles = props.articles
    .map((rawArticle) => new Article(rawArticle))
    .filter((article) => (options?.includeTypes ?? []).every((type) => filterConditionsMap[type](article))
      && (options?.excludeTypes ?? []).every((type) => !filterConditionsMap[type](article)));

  return {
    articles: options.sliceParams ? articles.slice(...options.sliceParams) : articles,
  };
}
